const PHOTO_ALBUM_BOOK_CENTER_PATCH = Symbol.for('eInvitation.photoAlbumBookCenter.v1')
const MOBILE_BREAKPOINT = 720

function clamp(value, minimum, maximum) {
  return Math.min(maximum, Math.max(minimum, value))
}

function getActivePageIndex() {
  const label = document.querySelector('.epa-bottom-nav span')
  const match = String(label?.textContent || '').match(/(\d+)\s*\/\s*(\d+)/)
  if (!match) return 0
  return Math.max(0, Number.parseInt(match[1], 10) - 1)
}

function getActivePanel(book) {
  const panels = Array.from(book.querySelectorAll('.epa-book-page > .epa-panel'))
  if (!panels.length) return null

  const expected = panels[getActivePageIndex()]
  if (expected) return expected

  return panels
    .map((panel) => ({ panel, rect: panel.getBoundingClientRect() }))
    .filter(({ rect }) => rect.width > 1 && rect.height > 1)
    .sort((left, right) => right.rect.width * right.rect.height - left.rect.width * left.rect.height)[0]?.panel || null
}

export function installPhotoAlbumBookCenter() {
  if (typeof document === 'undefined' || globalThis[PHOTO_ALBUM_BOOK_CENTER_PATCH]) return

  let animationFrame = 0
  let secondFrame = 0

  function centerActiveBookPage() {
    if (animationFrame) cancelAnimationFrame(animationFrame)
    if (secondFrame) cancelAnimationFrame(secondFrame)

    animationFrame = requestAnimationFrame(() => {
      animationFrame = 0

      const stage = document.querySelector('.epa-stage')
      const book = document.querySelector('.epa-flipbook.stf__parent')
      if (!(stage instanceof HTMLElement) || !(book instanceof HTMLElement)) return

      if (window.innerWidth > MOBILE_BREAKPOINT) {
        book.style.setProperty('--epa-mobile-book-offset-y', '0px')
        return
      }

      // Measure from the unshifted position so recalculation never accumulates.
      book.style.setProperty('--epa-mobile-book-offset-y', '0px')

      secondFrame = requestAnimationFrame(() => {
        secondFrame = 0
        const panel = getActivePanel(book)
        if (!(panel instanceof HTMLElement)) return

        const stageRect = stage.getBoundingClientRect()
        const panelRect = panel.getBoundingClientRect()
        if (!stageRect.height || !panelRect.height) return

        const desiredCenter = stageRect.top + stageRect.height / 2
        const actualCenter = panelRect.top + panelRect.height / 2
        const availableSpace = Math.max(0, stageRect.height - panelRect.height)
        const maximumShift = availableSpace / 2
        const offset = clamp(desiredCenter - actualCenter, -maximumShift, maximumShift)

        book.style.setProperty('--epa-mobile-book-offset-y', `${Math.round(offset)}px`)
      })
    })
  }

  function start() {
    centerActiveBookPage()
    window.setTimeout(centerActiveBookPage, 120)
    window.setTimeout(centerActiveBookPage, 500)

    const navLabel = document.querySelector('.epa-bottom-nav span')
    const navObserver = navLabel
      ? new MutationObserver(centerActiveBookPage)
      : null
    navObserver?.observe(navLabel, { childList: true, characterData: true, subtree: true })

    const domObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) {
        centerActiveBookPage()
      }
    })
    domObserver.observe(document.documentElement, { childList: true, subtree: true })

    const resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(centerActiveBookPage)
      : null

    const stage = document.querySelector('.epa-stage')
    const book = document.querySelector('.epa-flipbook.stf__parent')
    if (stage) resizeObserver?.observe(stage)
    if (book) resizeObserver?.observe(book)

    window.addEventListener('resize', centerActiveBookPage, { passive: true })
    window.addEventListener('orientationchange', centerActiveBookPage, { passive: true })
    window.addEventListener('load', centerActiveBookPage, { once: true })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }

  globalThis[PHOTO_ALBUM_BOOK_CENTER_PATCH] = true
}
